import styled from 'styled-components';
export const Date = styled.input`
    outline: none;
    display: flex;
    border: 0px;
    height: 100%;
    padding: 0.5rem;
    border-radius: 3px;   
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
    font-family: Montserrat,sans-serif;
`
